// ©2024 Austin App House. All rights reserved.
const values = {
  processingFee: 0,
};

export default values;
